
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryHorizontalCharging50 as ObiBatteryHorizontalCharging50Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-horizontal-charging-50.js';
 
 
 

 
 export const ObiBatteryHorizontalCharging50 = createComponent({
   react: React,
   tagName: 'obi-battery-horizontal-charging-50',
   elementClass: ObiBatteryHorizontalCharging50Element,
   events: {
     
   }
  });
 
 